import React from 'react';
import { Box, Pill } from '@edreamsodigeo/prisma-design-system';

const ALIGNMENTS = {
  start: {
    firstPill: {
      borderBottomLeftRadius: 0,
    },
    secondPill: {
      borderTopLeftRadius: 0,
    },
  },
  end: {
    firstPill: {
      borderBottomRightRadius: 0,
    },
    secondPill: {
      borderTopRightRadius: 0,
    },
  },
};

export interface DoublePillProps {
  firstPill: { render?: React.ReactNode; sx?: object };
  secondPill: { render?: React.ReactNode; sx?: object };
  alignment?: keyof typeof ALIGNMENTS;
}

const DoublePill = ({
  firstPill,
  secondPill,
  alignment = 'start',
}: DoublePillProps) => {
  if (!firstPill?.render || !secondPill?.render) {
    return null;
  }

  return (
    <Box sx={{ textAlign: alignment }}>
      <Box>
        <Pill
          type="neutral"
          sx={{
            color: 'neutral.100',
            backgroundColor: 'neutral.0',
            borderRadius: 'small',
            ...ALIGNMENTS[alignment].firstPill,
            ...firstPill.sx,
          }}
        >
          {firstPill.render}
        </Pill>
      </Box>
      <Box>
        <Pill
          type="promotional"
          sx={{
            borderRadius: 'small',
            ...ALIGNMENTS[alignment].secondPill,
            ...secondPill.sx,
          }}
        >
          {secondPill.render}
        </Pill>
      </Box>
    </Box>
  );
};

export default DoublePill;
